<template>
  <div>
    <ul class="nav-step mv-30 ph-80">
      <li class="on" :class="[getCurrentStep(0)]">
        <i>1</i>출입자 별 입실정보 입력</li>
      <li :class="[getCurrentStep(1)]">
        <i>2</i>출입자 공통정보 입력</li>
    </ul>
    <div class="box"  v-show="currentStep == 0">
      <div class="box-header">
        <h3>출입자 별 입실 정보 입력</h3>
        <small>신분증 보관 칸 번호, 출입증 번호, 자산 반입 여부, 기타 사항을 입력합니다.</small>
      </div>

      <div class="scroll-tbl">
        <div class="thead">
          <table class="tbl no-outline">
            <colgroup>
              <col width="40px">
              <col width="60px">
              <col width="120px">
              <col width="120px">
              <col width="auto">
              <col width="auto">
              <col width="auto">
            </colgroup>
            <thead>
              <tr>
                <th></th>
                <th>이름</th>
                <th>칸번호</th>
                <th>카드번호</th>
                <th>반입자산</th>
                <th>확인자산</th>
                <th>비고</th>
              </tr>
            </thead>
          </table>
        </div>
        <!--div class="tbody" style="height:450px" ui-jp="mCustomScrollbar" ui-options="{theme:'dark-thick'}"-->
        <div class="tbody scroll-wrap" style="height:310px; overflow: auto" >
          <table class="tbl no-outline">
            <colgroup>
              <col width="40px">
              <col width="60px">
              <col width="120px">
              <col width="120px">
              <col width="auto">
              <col width="auto">
              <col width="auto">
            </colgroup>
            <tbody>
              <tr v-for="(item, index) in data" :key="index">
                <td>
                  <label class="md-check">
                    <!--input type="radio" name="radio" class="has-value">
                    <i class="blue"></i-->
                  </label>
                </td>
                <td>{{item.visitor.visitorName}}</td>
                <td><input type="text" class="form-control" v-model="item.spaceNumber"/></td>
                <td><input type="text" class="form-control" v-model="item.cardNumber"/></td>
                <td>
                  <AssetList :value="item.visitor.assetList" :height="140" :editMode="true" @change="changeHandler"/>
                </td>
                <td>
                  <AssetList :value="item.visitor.assetList" :height="140" valueKey="confirmed" @change="changeHandler" :editMode="true"/>
                </td>
                <td><textarea class="form-control w430" :placeholder="item.visitor.etc" style="height:100px" v-model="item.memo" @input="changeHandler"></textarea></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="box"  v-show="currentStep == 1">
      <div class="box-header">
        <h3>출입자 공통 정보 입력</h3>
        <small>전체 출입자에 공통으로 해당되는 정보들을 입력합니다.</small>
      </div>
      <div class="box-body">
        <form action="">
          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span class="ess">인솔자</span>
            </label>
            <div class="col-9 pt-2">
              <input type="text" v-model="commonData.uuid"  class="form-control form-control-success" v-if="false">
              <input type="text" v-model="commonData.accompanyEmpName"  class="form-control form-control-success">
            </div>
          </div>
          <div class="form-group row pr-35">
            <label class="col-2 form-control-label">
              <span class="ess">출입위치 관리</span>
            </label>
            <div class="col-10">

              <div class="transfer transfer-box">
                <LocationList2 ref="fromList" :reservedLocationList="JSON.parse(data[0].visitor.visitLocation)" :editMode="true" :idcCode="data[0].visitor.visitIdcCode"/>

                <!--<LocationList2 ref="fromList" :staticSource="locationDataList" :editMode="true" :idcCode="visitIdcCode"/>-->
                <div class="transfer-controls">
                  <div class="btn btn-l line-4 ltr" @click="toToData()">
                    <i class="icon-arrow-line-right-centered"></i>
                  </div>
                  <div class="btn btn-l line-4 rtl mt-6" @click="toFromData()">
                    <i class="icon-arrow-line-left-centered"></i>
                  </div>
                </div>
                <LocationList2 ref="toList" :reservedLocationList="saveLocationList" :editMode="true" :idcCode="data[0].visitor.visitIdcCode" :disableInitData="true"/>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span class="ess">입실 처리 직원</span>
            </label>
            <div class="col-9 pt-2">
              <input type="text" v-model="commonData.checkInEmployeeName"  class="form-control form-control-success">

            </div>
          </div>
        </form>
      </div>
    </div>


    <div class="btn-wrap justify-content-center mt-30 mb-40">
      <button class="btn btn-lg white" @click="prevStep()" v-if="currentStep > 0">
        <i class="icon-arrow-line-left mr-5"></i>이전</button>
      <button class="btn btn-lg blue" @click="nextStep()" :disabled="isNextDisabled" v-if="currentStep < 1">다음
        <i class="icon-arrow-line-right ml-5" ></i>
      </button>
      <button class="btn btn-lg blue"  @click="save()" :disabled="checkSave" v-if="currentStep == 1">완료
        <i class="icon-check ml-5" ></i>
      </button>
    </div>
  </div>
</template>

<script>
import LocationTable from './LocationTable.vue';
import AssetList from './AssetList.vue';
import LocationList from './LocationList.vue';
import LocationList2 from './LocationList2.vue';
import LocationBase from '@/components/common/locationBase'

export default {
  mixins: [LocationBase],
  components: { LocationTable,AssetList, LocationList, LocationList2 },
  props: {
    title: String,
    data : {
      default: [],
    },

  },
  data(){
    return {
      //data: null,
      assets: [{name: 'note'}],
      currentStep: 0,
      commonData: {uuid:''},
      locationDataList: [],
      saveLocationList: [],
      fromListData: [],
      toListData:[],
      visitIdcCode: null,
      isNextDisabled: false
    }
  },
  computed: {
    getAssetItem(){
      return (item) =>{
        return item.visitor.assetList;
      }
    },
    checkSave(){
      if(!this.commonData.uuid){
        return true;
      }
      if(!this.commonData.accompanyEmpName){
        return true;
      }
      if(!this.commonData.checkInEmployeeName){
        return true;
      }
      if(this.saveLocationList.length == 0){
        return true;
      }
      return false;
    },
    checkNext(){
      var result = false
      var that = this;
      this.data.forEach((item, index) =>{
        // if(!item.spaceNumber){
        //   result = true;
        //   return;
        // }
        // if(!item.cardNumber){
        //   result = true;
        //   return;
        // }

        if(item.visitor.assetList.filter(x=>x.checked).length  != item.visitor.assetList.filter(x=>x.confirmed).length){
          result = true;
          return false;
        }
      })
      return result;
    },
    isSelected(){
      item.visitor.assetList.filter(x => x.checked)
    },
    checkedAssets() {
      return (item) =>{
        return item.visitor.assetList;
      }
    },

    getAssetName(){
      return (asset) =>{
        return asset.assetStr + '('+ asset.assetSerial + ')';
      }
    },
    getCurrentStep(){
      return (step) =>{
        var result = ''
        if(step < this.currentStep)
          result = 'checked';
        if(this.currentStep == step)
          result = 'on'
        return result;
      }
    }
  },
  mounted(){

    console.log(this.data);

    this.$nextTick(()=>{
      this.commonData.uuid = this.uuidv4();
    })
    this.currentStep = 0;
    setTimeout(()=>{
      $('.scroll-wrap').mCustomScrollbar({
        theme: 'minimal-dark',
      });

    },500)

  },
  methods: {
    changeHandler(items){

      this.isNextDisabled = false;

      this.data.forEach( (dt) => {

        dt.visitor.assetList.forEach( (asset) => {
          if(asset.checked){
            if(!asset.confirmed) {
              this.isNextDisabled = true;
              return ;
            }
            else {
              if(dt.memo == null || dt.memo == '') {
                this.isNextDisabled = true;
                return ;
              }
            }
          }
        })
      });


      // this.isNextDisabled = false;
      //
      // items.forEach((x)=>{
      //
      //   // console.log(x.visitorAssetCode.assetStr + " : " + x.checked + " : " +x.confirmed);
      //   // x.checked = !x.checked;
      //   // x.checked = !x.checked;
      //
      //   // if(x.checked == true){
      //   //   x.checked=true;
      //   // }else{
      //   //   x.checked=false;
      //   // }
      //   if(x.checked && !x.confirmed) this.isNextDisabled = true;

      // })
    },
    toToData(){
      let from = this.$refs.fromList.selectedItems;
      this.saveLocationList = from.map(x => x.code).concat(this.saveLocationList);
      this.$refs.toList.enableLocationList(this.saveLocationList);

      from.forEach(x => {
        x.hide = true;
        x.checked = false;
      })

    },
    toFromData(){
      var to = this.$refs.toList.selectedItems.filter(x=>x.reserved);
      this.$refs.fromList.enableLocationList(to.map(x => x.code).concat(this.saveLocationList));

      let removeList = to.map(y => {
        return y.code[y.code.length-1];
      });

      this.saveLocationList = this.saveLocationList.filter((x)=>{
        return !removeList.includes(x[x.length-1]);
      });

      to.forEach(x=>{
        x.hide = true;
        x.checked = false;
      })

    },

    save(){

      var list = this.copyNew(this.data);

      var saveList = [];
      list.forEach(o => {
        let obj = {};

        obj.spaceNumber = o.spaceNumber;
        obj.cardNumber = o.cardNumber;
        obj.assetList = _.map(o.visitor.assetList.filter(x => x.checked), z=>{
          return z.visitorAssetIndex;
        });
        obj.memo = o.memo

        obj.accompanyEmpName = this.commonData.accompanyEmpName;
        obj.locationList = this.saveLocationList;
        obj.checkInEmployeeName = this.commonData.checkInEmployeeName;

        obj.checkInIndex = o.checkInIndex;
        obj.uuid = o.visitor.uuid;

        saveList.push(obj);
        console.log(saveList);
      });

      this.$http.post('/api/private/visitor/checkIn', saveList)
        .then((result) => {
          // this.$toast.success('입실 완료 되었습니다.');
          this.noti('완료', '입실 완료 되었습니다.', 'success');
          this.closeModal();
          this.$attrs.opener.findAll();
        }).catch((e) =>{
          console.log(e);
      })
    },
    nextStep(){
      if(this.currentStep == 0){

        this.currentStep +=1;

        this.visitIdcCode = this.data[0].visitor.visitIdcCode;
        this.locationDataList = this.getParseLocation(this.data[0].visitor.visitLocation);
        this.locationDataList.forEach(x=>{
          x.reserved = true;
        })
      }
    },
    getAssetType(code) {
      return _.find(this.$store.getters['dataprovider/asset'],{'assetCode': code})
    },
    prevStep(){
      if(this.currentStep > 0)
        this.currentStep -=1;
    },
  }
}
</script>

<style>

</style>
